import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "popUpWindow" }
const _hoisted_2 = { class: "stepHeader" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", { class: "primaryShort" }, null, -1)
const _hoisted_4 = { class: "verificationStatus" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_check-round icon" }, null, -1)
const _hoisted_6 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t("forgotten_password.title")), 1)
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("forgotten_password.password_changed")), 1)
    ]),
    _createVNode(_component_Button, {
      class: "defaultButton",
      label: _ctx.$t(`global.login`),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'Login' })))
    }, null, 8, ["label"])
  ]))
}